import React from 'react';
import { useParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import InterviewSession from '../components/InterviewSession';

const PrescreeningInterview = () => {
    const { interviewId } = useParams();
    
    // API endpoints configuration for pre-screening interviews
    const apiEndpoints = {
        fetch: `pre-screening-interviews/${interviewId}/`,
        start: `pre-screening-interviews/${interviewId}/start`,
        startQuestion: `pre-screening-interviews/${interviewId}/start_question/:questionNumber`,
        submitQuestion: `pre-screening-interviews/${interviewId}/submit_question/:questionNumber`,
        end: `pre-screening-interviews/${interviewId}/end`,
        proctor: `pre-screening-interviews/${interviewId}/proctor-events`
    };
    
    // Navigation configuration
    const navigationConfig = {
        backPath: "/",
        backText: "Back to Home",
        successPath: "/",
        successButtonText: "Return to Home",
        successMessage: "Interview completed successfully! You can now return to the home page."
    };

    return (
        <>
            <Navigation />
            <InterviewSession 
                interviewId={interviewId}
                workTrialId={null}
                apiEndpoints={apiEndpoints}
                navigationConfig={navigationConfig}
                interviewType="Pre-Screening Interview"
            />
        </>
    );
};

export default PrescreeningInterview;